// A player's Valor Tools card on their profile (Oct 15 2026): career kill scores added up across every world, the worlds, the
// motto, and a link to the full card. Only for players Valor Tools switched Valor Web on for, and only when the card's own
// visibility lets them see it (Valor Tools src/cards.js canView).
import { Button, Card, CardHead } from "@/kit/primitives";
import { fmtNum, plural } from "@/game/format";
import { openTools, useVtCard, useVtOn } from "@/state/vt";

export function VtPlayerCard({ wid, name, me }: { wid: number; name: string | null | undefined; me: boolean }) {
  const on = useVtOn(wid);
  const q = useVtCard(wid, name);
  if (!on || !name) return null;
  const card = q.data?.card;
  if (!card) {
    if (!me || q.isLoading) return null;
    return (
      <Card className="vt-pcard">
        <CardHead title="Valor Tools card" />
        <p className="muted" style={{ margin: "0 0 calc(var(--u) * 12)", font: "400 var(--fs-body2)/1.45 var(--text)" }}>Your career kill scores across every world, on one card you can share.</p>
        <Button size="sm" kind="gold" onClick={() => openTools(wid, "/account/card/", true)}>Make my card</Button>
      </Card>
    );
  }
  const ws = card.worlds ?? [];
  const sum = ws.reduce((a, w) => ({ ksa: a.ksa + (w.ksa || 0), ksd: a.ksd + (w.ksd || 0), kst: a.kst + (w.kst || (w.ksa || 0) + (w.ksd || 0)) }), { ksa: 0, ksd: 0, kst: 0 });
  const slug = card.slug;
  return (
    <Card className="vt-pcard">
      <CardHead title="Valor Tools card" aside={plural(ws.length, "world")} />
      {card.motto ? <p className="vt-motto" style={{ margin: "0 0 calc(var(--u) * 10)", font: "italic 400 var(--fs-body2)/1.4 var(--serif)", color: "var(--cream-t)" }}>“{card.motto}”</p> : null}
      <div className="pf-stats vt-career" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "calc(var(--u) * 10)", textAlign: "center" }}>
        <div><div className="lbl">Career total</div><div className="val gold">{fmtNum(sum.kst)}</div></div>
        <div><div className="lbl">Attacking</div><div className="val">{fmtNum(sum.ksa)}</div></div>
        <div><div className="lbl">Defending</div><div className="val">{fmtNum(sum.ksd)}</div></div>
      </div>
      {ws.length > 1 && (
        <p className="muted" style={{ margin: "calc(var(--u) * 10) 0 0", font: "400 var(--fs-meta)/1.4 var(--text)" }}>
          {ws.map((w) => `${w.name || `World ${w.wid}`}${w.tag ? ` [${w.tag}]` : ""}`).join(" · ")}
        </p>
      )}
      {slug && (
        <div style={{ marginTop: "calc(var(--u) * 12)", display: "flex", gap: "calc(var(--u) * 8)", flexWrap: "wrap" }}>
          <Button size="sm" onClick={() => openTools(wid, `/c/${slug}`, true)}>Open card</Button>
          {me && <Button size="sm" kind="ghost" onClick={() => openTools(wid, "/account/card/", true)}>Edit</Button>}
        </div>
      )}
    </Card>
  );
}
